// extracted by mini-css-extract-plugin
export default {"search":"FoldersComponent_search__aA4Lv","highlightedNode":"FoldersComponent_highlightedNode__brAkj"};